var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpandMapIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand",
    transform: "translate(-178.611 -658.612)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10893",
    "data-name": "Rectangle 10893",
    width: 9.339,
    height: 9.339,
    transform: "translate(180 659.885)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16798",
    "data-name": "Path 16798",
    d: "M189.286,678.714H200A1.383,1.383,0,0,1,198.714,680h-9.429A1.383,1.383,0,0,1,188,678.714h0v-9.428h1.286ZM200,674.857h-1.286v3.857H200ZM200,668v4.286h-1.26V670.18l-4.535,4.535-.92-.92,4.509-4.509h-2.08V668Zm-10.714,0h3.857v1.286H188A1.383,1.383,0,0,1,189.286,668Z",
    transform: "translate(-9.389 -9.388)",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpandMapIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Expand_Map_icon.76b4703162987e7f23f6ba74be110d43.svg";